import React, { FC } from 'react';
import classnames from 'classnames';
import { Asset, CheckmarkIcon, InfoIcon, WarningIcon } from '@clearcover/atlas';

import styles from './styles.module.css';

export type NpnStatusType =
  | 'invalid'
  | 'not_applicable'
  | 'success'
  | 'sync_in_progress'
  | 'syncing_error'
  | 'unknown';

export const NPN_STATUS_MAPPINGS: {
  [index: string]: {
    message: string;
    style: string;
    icon: React.MemoExoticComponent<
      (props: React.SVGProps<SVGSVGElement>) => React.JSX.Element
    >;
  };
} = {
  sync_in_progress: {
    message: 'Sync In Progress',
    style: styles.info,
    icon: InfoIcon,
  },
  syncing_error: {
    message: 'Syncing Error',
    style: styles.error,
    icon: WarningIcon,
  },
  success: {
    message: 'NPN Verified',
    style: styles.success,
    icon: CheckmarkIcon,
  },
  invalid: {
    message: 'Invalid NPN',
    style: styles.error,
    icon: WarningIcon,
  },
  unknown: {
    message: 'Sync In Progress',
    style: styles.info,
    icon: InfoIcon,
  },
};

export type NpnStatusProps = {
  status?: NpnStatusType;
  className?: string;
};

export const NpnStatus: FC<NpnStatusProps> = ({ status, className }) => {
  if (!status || !NPN_STATUS_MAPPINGS.hasOwnProperty(status)) return null;

  const npnStatusDisplay = NPN_STATUS_MAPPINGS[status];

  return (
    <div className={styles.npnStatusWrapper}>
      <div
        data-testid="npn-status"
        className={classnames(npnStatusDisplay.style, className)}
      >
        <Asset
          icon={npnStatusDisplay.icon}
          height={14}
          width={14}
          description="npn status icon"
        />
        <div className={styles.message}>{npnStatusDisplay.message}</div>
      </div>
    </div>
  );
};
